import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getValue } from '../Hero/functions'
import useEmblaCarousel from 'embla-carousel-react'
import { isEmpty, uniqueId } from 'lodash'
import AutoScroll from 'embla-carousel-auto-scroll'
import { useMediaQuery } from '@uidotdev/usehooks'

import './styles/embla.scss'

SliderBrands.propTypes = {
  data: PropTypes.object,
}

const Colors = {
  bk_eerie_black: 'bg-eerie-black',
  bk_air_force_blue: 'bg-force-blue',
  bk_isabelline: 'bg-isabelline',
}

export default function SliderBrands({ data }) {
  const isExtraLargeDevice = useMediaQuery('only screen and (min-width : 1201px)')

  const [emblaRef] = useEmblaCarousel({ loop: true, stopOnInteraction: false }, [
    AutoScroll({
      speed: 1,
      stopOnMouseEnter: true,
      stopOnInteraction: false,
    }),
  ])

  const bgColor = Colors[data?.background_color]

  const brands = useMemo(() => {
    const _data = data?.brands

    if (isEmpty(_data)) return []

    if (!isExtraLargeDevice) return _data

    return [..._data, ..._data]
  }, [isExtraLargeDevice, data?.brands])

  if (isEmpty(brands)) return null

  return (
    <section
      className={`${bgColor} overflow-hidden w-screen pt-4 pb-[71px] lg:pb-[110px] flex flex-col items-center justify-center mt-[-8px]`}
    >
      <div className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          {!isEmpty(brands) ? (
            <div className="embla__container">
              {brands?.map((item) => {
                const brandKey = uniqueId()
                const brand = item?.brand

                return (
                  <div key={brandKey} className="embla__slide">
                    <img
                      src={brand?.url}
                      alt={getValue(brand?.alt)}
                      title={getValue(brand?.title)}
                      description={getValue(brand?.description)}
                      caption={getValue(brand?.caption)}
                      author={getValue(brand?.author)}
                    />
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}
